import { render, staticRenderFns } from "./InvestmentFeeDisclaimer.vue?vue&type=template&id=10f752f5"
import script from "./InvestmentFeeDisclaimer.vue?vue&type=script&lang=ts"
export * from "./InvestmentFeeDisclaimer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports